import api from "./api";

const API_URL = "/admin/libraries";

const createLibrary = async (libraryData) => {
  const { feedbackId, ...rest } = libraryData;
  const params = {};
  if (feedbackId) {
    params.feedbackId = feedbackId;
  }
  const response = await api.post(API_URL, rest, { params });
  return response.data;
};

const updateLibrary = async (id, libraryData) => {
  const { feedbackId, ...rest } = libraryData;
  const params = {};
  if (feedbackId) {
    params.feedbackId = feedbackId;
  }
  const response = await api.put(`${API_URL}/${id}`, rest, { params });
  return response.data;
};

const getLibrariesByChitalishteId = async (chitalishteId) => {
    const response = await api.get(`/chitalishta/${chitalishteId}/libraries`);
    return response.data;
};


const libraryAdminService = {
  createLibrary,
  updateLibrary,
  getLibrariesByChitalishteId,
};

export default libraryAdminService;
